import { __read, __spreadArray } from "tslib";
import { log } from './broadcastLogger';
import { LogKind } from './log.types';
// The wrapper intend to handle any function
/* eslint-disable @typescript-eslint/no-explicit-any */
export function handlerWithAnalytics(onInvoke, hint, payload, payloadCallback) {
    return function wrappedHandler() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (payloadCallback !== undefined) {
            payload = payloadCallback.call.apply(payloadCallback, __spreadArray([this, payload], __read(args)));
        }
        log({ id: hint, type: LogKind.Analytics, data: JSON.stringify(payload) });
        if (typeof onInvoke === 'function') {
            return onInvoke.call.apply(onInvoke, __spreadArray([this], __read(args)));
        }
        return;
    };
}
export function logAnalytics(id, data) {
    if (data === void 0) { data = ''; }
    log({
        id: id,
        type: LogKind.Analytics,
        data: data,
    });
}
export function scrubMessage(message) {
    // scrub the message, if it is a string
    var scrubbedMessage = message;
    try {
        if (typeof message === 'string') {
            // replace UPN, %40 is an encoded @
            scrubbedMessage = scrubbedMessage
                .replaceAll(/[a-zA-Z0-9_\-'.]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+/g, '<upn>')
                .replaceAll(/[a-zA-Z0-9_\-'.]+%40[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+/g, '<upn>');
            // replace tokens
            scrubbedMessage = scrubbedMessage
                .replaceAll(/eyJ0eX[A-Za-z0-9-_]+\.+[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=/]+/g, '<token>')
                .replaceAll(/eyJhbG[A-Za-z0-9-_]+\.+[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=/]+/g, '<token>');
        }
    }
    catch (_a) {
        // do nothing
    }
    return scrubbedMessage;
}
export function logError(id, error, message, data) {
    log({
        id: id,
        data: data,
        type: LogKind.Error,
        error: error,
        message: message || error.message,
    });
}
var ariaLoggerId;
export function setAriaLoggerId(ariaLogId) {
    ariaLoggerId = ariaLogId;
}
export function getAriaLoggerId() {
    return ariaLoggerId;
}
export function getErrorMessage(error) {
    return JSON.stringify(error);
}
